<div class="container">
    <research-layout [config]="layoutConfig">
        <ng-template #refinedBy>
            <div class="finder-box" *ngIf="!isEntityFocusHidden&&!config.advFilter">
                <finder [config]="finderConfig"></finder>
            </div>
            <div
                [ngClass]="{'refineby-panel-has-finder':!isEntityFocusHidden&&!config.advFilter,'refineby-panel-no-finder':isEntityFocusHidden||config.advFilter}">
                <div class="tab-box" [style.display]="!isRelationshipTreeHidden&&!config.advFilter ? '' : 'none'">
                    <tabs [options]="tabsOptions" [underlineStyle]="true" tid="refineby_tabs"></tabs>
                </div>
                <div [style.display]="currentTab===0||isRelationshipTreeHidden||config.advFilter ? '' : 'none'"
                    [ngClass]="{'refineby-box-has-relationship': !isRelationshipTreeHidden&&!config.advFilter, 'refineby-box-no-relationship': isRelationshipTreeHidden||config.advFilter}">
                    <research-refineby [config]="refinebyConfig"></research-refineby>
                </div>
                <div *ngIf="currentTab===1&&!isRelationshipTreeHidden&&!config.advFilter" class="relationship-box"
                    loading-spin [isLoading]="isRelationshipLoading" [loadingSize]="'big'">
                    <div *ngIf="!isRelationshipLoading">
                        <relationship-tree [config]="relationshipTreeConfig"></relationship-tree>
                    </div>
                </div>
            </div>
        </ng-template>
        <ng-template #snippet>
            <div class="list-container" tid="snippet-note-list-panel">
                <div class="tool-bar">
                    <div class="search-box">
                        <div [ngClass]="{'plain-container': !config.embedMode,'hidden':config.embedMode}">
                            <keyword-search [config]="keywordSearchConfig"></keyword-search>
                        </div>
                        <div class="counter-box">
                            <span>{{threadListTotalCount$ | async}} items</span>
                        </div>
                    </div>
                    <div class="button-box" kendoTooltip tooltipClass="tooltip-adjust-right">
                        <smart-icon tid="refresh_icon" name="refresh" (click)="onRefreshClicked()" class="light"
                            title="Refresh">
                        </smart-icon>
                        <sort [sortInfo]="sortInfo" (change)="onSortSelect($event)"
                            [sortChangeSubject]="sortChangeSubject" title="Sort"></sort>
                        <display [config]="displayConfig" title="Filter"></display>
                        <smart-icon *ngIf="isAdminUser && isComplianceUser" tid="append_entity_icon" name="replace"
                            (click)="onAppendClicked()" class="light icon-replace"
                            title="Append entity(s) to filtered notes.">
                        </smart-icon>
                        <layout [config]="layoutMenuConfig" title="Change View"></layout>
                    </div>
                </div>
                <div class="list-pane">
                    <snippet-thread-list [config]="threadListConfig"></snippet-thread-list>
                </div>
            </div>
        </ng-template>
        <ng-template #preview>
            <div class="thread-detail-box" loading-spin [isLoading]="isThreadDetailLoading" [loadingSize]="'big'">
                <thread-detail [config]="threadDetailConfig"></thread-detail>
            </div>
        </ng-template>
        <ng-template #sideList>
            <div class="list-container" tid="side-note-list-panel">
                <div class="tool-bar">
                    <div class="search-box">
                        <div [ngClass]="{'plain-container': !config.embedMode,'hidden':config.embedMode}">
                            <keyword-search [config]="keywordSearchConfig"></keyword-search>
                        </div>
                        <div class="counter-box">
                            <span>{{threadListTotalCount$ | async}} items</span>
                        </div>
                    </div>
                    <div class="button-box" kendoTooltip tooltipClass="tooltip-adjust-right">
                        <smart-icon tid="refresh_icon" name="refresh" (click)="onRefreshClicked()" class="light"
                            title="Refresh">
                        </smart-icon>
                        <display [config]="displayConfig" title="Filter"></display>
                        <smart-icon *ngIf="isAdminUser && isComplianceUser" tid="append_entity_icon" name="replace"
                            (click)="onAppendClicked()" class="light icon-replace"
                            title="Append entity(s) to filtered notes.">
                        </smart-icon>
                        <layout [config]="layoutMenuConfig" title="Change View"></layout>
                    </div>
                </div>
                <div class="list-pane">
                    <top-thread-list [config]="threadListConfig"></top-thread-list>
                </div>
            </div>
        </ng-template>
        <ng-template #topList>
            <div class="list-container" tid="top-note-list-panel">
                <div class="tool-bar">
                    <div class="search-box">
                        <keyword-search [config]="keywordSearchConfig"></keyword-search>
                        <div class="counter-box">
                            <span>{{threadListTotalCount$ | async}} items</span>
                        </div>
                    </div>
                    <div class="button-box" kendoTooltip tooltipClass="tooltip-adjust-right">
                        <smart-icon tid="refresh_icon" name="refresh" (click)="onRefreshClicked()" class="light"
                            title="Refresh">
                        </smart-icon>
                        <display [config]="displayConfig" title="Filter"></display>
                        <smart-icon *ngIf="isAdminUser && isComplianceUser" tid="append_entity_icon" name="replace"
                            (click)="onAppendClicked()" class="light icon-replace"
                            title="Append entity(s) to filtered notes.">
                        </smart-icon>
                        <layout [config]="layoutMenuConfig" title="Change View"></layout>
                    </div>
                </div>
                <div class="list-pane">
                    <top-thread-list [config]="threadListConfig"></top-thread-list>
                </div>
            </div>
        </ng-template>
    </research-layout>
    <tam-map-tile-dialog></tam-map-tile-dialog>
</div>